import { Storage } from 'aws-amplify'

const BUCKET = 'walllabs-bucket'
const REGION = 'us-east-1'

function getExtension(fileName = '', mimeType = '') {
  const fromName = String(fileName).match(/\.(png|jpe?g|webp|gif|jfif)$/i)?.[1]
  if (fromName) return fromName.toLowerCase() === 'jpeg' ? 'jpg' : fromName.toLowerCase()

  const fromType = String(mimeType).replace('image/', '').toLowerCase()
  if (['png', 'jpg', 'jpeg', 'webp', 'gif', 'jfif'].includes(fromType)) {
    return fromType === 'jpeg' ? 'jpg' : fromType
  }

  return 'png'
}

function sanitizeNameSegment(name = '') {
  const normalized = String(name || '')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[\\/:*?"<>|#%{}^~[\]`]/g, '')
  return normalized || 'wallpaper'
}

function encodeKeyForUrl(key) {
  return String(key || '')
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/')
}

export function buildS3Key(wallpaperName, file) {
  const base = sanitizeNameSegment(wallpaperName)
  const extension = getExtension(file?.name, file?.type)
  return `wallpaper/${base}.${extension}`
}

export function getPublicS3Url(key) {
  const cleaned = String(key || '').replace(/^\/+/, '')
  return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${encodeKeyForUrl(cleaned)}`
}

export async function uploadToS3(file, key) {
  if (!file) throw new Error('No file selected')
  if (!key) throw new Error('No S3 key provided')

  try {
    await Storage.put(key, file, {
      level: 'public',
      contentType: file.type || 'application/octet-stream',
      bucket: BUCKET,
      region: REGION,
      customPrefix: { public: '' }
    })
    return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${encodeKeyForUrl(key)}`
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      const proxyUrl = `/upload-s3/${encodeKeyForUrl(key)}`
      const response = await fetch(proxyUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type || 'application/octet-stream'
        },
        body: file
      })
      if (response.ok) {
        return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${encodeKeyForUrl(key)}`
      }
    }
    throw new Error(
      error?.message || 'S3 upload failed. Check Amplify config, IAM, and bucket policy.'
    )
  }
}
